export const colors = [
  '#ffa000',
  '#ffec8e',
  '#cccccc',
  '#fff',
];



// WEBPACK FOOTER //
// src/routes/cms/components/confog.js